import axios, { AxiosRequestConfig, Method } from 'axios';
import { API_URL, AUTH_TOKEN_STORAGE_KEY } from './constants';

const fetch = async (
  url: string,
  method: Method,
  data?: object,
  headers: object = {},
): Promise<object> => {
  const axiosOptions: AxiosRequestConfig = {
    url: `${API_URL}${url}`,
    method,
    data,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json;charset=UTF-8',
      ...headers,
    },
  };

  const token = localStorage.getItem(AUTH_TOKEN_STORAGE_KEY);
  if (token) {
    axiosOptions.headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await axios(axiosOptions);
    const responseData = await response.data;
    return responseData;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else if (error.request) {
      throw error.request;
    } else {
      throw error.message;
    }
  }
};

export const login = (body: object): Promise<object> =>
  fetch(`/users/signin`, 'post', body);
export const fetchAllBlocks = (): Promise<object> => fetch(`/blocks`, 'get');
export const fetchBlock = (id: number): Promise<object> =>
  fetch(`/blocks/${id}`, 'get');
export const createBlock = (body: object): Promise<object> =>
  fetch(`/blocks`, 'post', body);
export const updateBlock = (body: object, id: number): Promise<object> =>
  fetch(`/blocks/${id}`, 'put', body);
export const partialUpdateBlock = (body: object, id: number): Promise<object> =>
  fetch(`/blocks/${id}`, 'patch', body);
export const deleteBlock = (body: object, id: number): Promise<object> =>
  fetch(`/blocks/${id}`, 'delete', body);
